import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogTitle, Divider, Grid, Tooltip, Typography } from "@mui/material";
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import { BtnCancel, BtnConfirm } from 'components/Common/Button';
import { GridColumns } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { DataGridMuiClient } from 'components/Common/Table/DataGridMuiClient';
import { WiTime9 } from "react-icons/wi";
import { AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import Zoom from '@mui/material/Zoom';


const ModalInformInprogress = (props) => {

    const {
        IsOpen,
        setIsOpen,
        sVOCFormID,
        sMaxWidth = "md",
        DataUser,
        DataRowInprogress,
        setDataRowInprogress
    } = props;

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any


    const schema = yup.object().shape({
        sDetail: yupFormSchemas.string("รายละเอียด", { required: true }),
    });

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })

    useEffect(() => {
        if (IsOpen) {
            onLoadData()
        }
    }, [IsOpen])

    const onAddNote2Table = () => {

        let sDetail = form.getValues("sDetail");

        var data = {
            sVOCFormID: sVOCFormID,
            sDetail: sDetail
        }
        AxiosPost(`VOC/ProgressReport`, data, (res) => {
            ResultAPI(res, null, async () => {
                let Result = res.result.sVOCFormID
                if (Result != null) {
                    let sHTML = <><p>บันทึกข้อมูลสำเร็จ</p></>
                    setIsOpenSnackbar(true);
                    setsMessageSnackbar(sHTML)
                    setsSeveritySnackbar("success")
                    onLoadData()
                } else {

                }

                form.setValue("sDetail", null)
            })
        })
    }

    const onLoadData = () => {

        let data = {
            sVOCFormID: sVOCFormID,
        }

        AxiosPost(`VOC/GetNotifyProgress`, data, (res) => {
            ResultAPI(res, null, async () => {
                let Result = res.result.data
                if (Result != null) {
                    setDataRowInprogress(Result)
                }
            })
        })
    }

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 40,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sDetail",
            headerName: "รายละเอียด",
            headerAlign: "center",
            flex: 4,
            align: "left",
            resizable: false,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                return (
                    <Tooltip title={item.value} TransitionComponent={Zoom} placement="top-start" >
                        <Typography component={"label"}>{item.value} </Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: "sUpdateBy",
            headerName: "ผู้บันทึก",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: false,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
        },
        {
            field: "dUpdate",
            headerName: "วันที่บันทึก",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: false,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
    ];

    return (

        <>
            <Dialog
                open={IsOpen}
                onClose={() => { setIsOpen(false) }}
                fullWidth={true}
                maxWidth={sMaxWidth}
            >
                <DialogTitle>แจ้งความก้าวหน้า</DialogTitle>
                <hr style={{ width: '100%', margin: '0' }} />
                <DialogContent>
                    <FormProvider {...form}>
                        <Grid container spacing={2} direction="row" justifyContent="end" alignItems="center">
                            <Grid item xs={12}>
                                <InputCustomLabel
                                    id="sDetail"
                                    name="sDetail"
                                    label="รายละเอียด"
                                    required={true}
                                    multiline={true}
                                    maxLength={1000}
                                    rows={4}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2} direction="row" justifyContent="end" alignItems="center" >
                                    <Grid item>
                                        <BtnConfirm txt={"ยืนยัน"} onClick={form.handleSubmit(() => { onAddNote2Table() })} />
                                    </Grid>
                                    <Grid item>
                                        <BtnCancel txt={"ยกเลิก"} onClick={() => { setIsOpen(false) }} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider textAlign="left"> <span style={{ display: 'flex', alignItems: 'center' }}><WiTime9 style={{ fontSize: '2em' }} />{" "}ประวัติการแจ้งความก้าวหน้า</span></Divider>
                            </Grid>
                            <Grid item xs={12}>
                                <DataGridMuiClient
                                    isLoading={false}
                                    rows={DataRowInprogress}
                                    HiddenToolHead={true}
                                    Columns={dataColumn}
                                    backgroundHeaderCustom={"#004290"}
                                    sxCustomHeader={{ color: '#ffffff' }}
                                />
                            </Grid>
                        </Grid>

                    </FormProvider>
                </DialogContent>

            </Dialog>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>

    )
}

export default ModalInformInprogress